<template lang='pug'>
    #card-totalizadores-dashboard-operacao
        h2.mb-4 {{ $t('mensagens.operacao.dashboard.totalizadores') }}

        .row.m-0
            .col-4.p-0
                el-skeleton(:rows='1' :loading='loading' animated)
                    template(v-slot:template)
                        .row.m-0
                            .colunas__card.col-6.p-0.mb-2(
                                v-for='(__, index) in loadingSkeleton', :key='index'
                                :class="definirEspacamentoColunas(index)"
                            )
                                el-skeleton-item.card-totalizadores-dashboard-operacao__cards__skeleton(
                                    variant="react"
                                )

                    template
                        .row.m-0(v-if="erro")
                            .colunas__card.col-6.p-0.mb-2(
                                v-for='(__, index) in errorPayload', :key='index'
                                :class="definirEspacamentoColunas(index)"
                            )
                                .card-totalizadores-dashboard-operacao__card
                                    span.card-totalizadores-dashboard-operacao__total --
                                    span.card-totalizadores-dashboard-operacao__descricao {{ $t('mensagens.operacao.dashboard.semInformacoes') }}

                        .row.m-0(v-if="!erro")
                            .colunas__card.col-6.p-0.mb-2(
                                v-for='(value, index) in payload', :key='index'
                                :class="definirEspacamentoColunas(index)"
                            )
                                .card-totalizadores-dashboard-operacao__card(@click="selecionarCardTotalizador(value)" :style="definirCorCard(value)")
                                    span.card-totalizadores-dashboard-operacao__total {{ value.total }}
                                    span.card-totalizadores-dashboard-operacao__descricao {{ $t(`mensagens.operacao.dashboard.totalizador.${value.codigo}`) }}

            .col-8.pr-0
                el-skeleton(:rows='1' :loading='dadosGrafico.loading || dadosTabela.loading' animated)
                    template(v-slot:template)
                        .card-totalizadores-dashboard-operacao__grafico__tabela
                            el-skeleton-item.card-totalizadores-dashboard-operacao__grafico__tabela--skeleton(variant="react")

                    template
                        .card-totalizadores-dashboard-operacao__grafico__tabela
                            .card-totalizadores-dashboard-operacao__grafico__tabela--grafico(
                                v-if='mostrarGrafico'
                                :style='dadosGrafico.erro || (!dadosGrafico.payload || dadosGrafico.payload.length === 0) ? "opacity: 0.7" : ""'
                            )
                                div.w-100.h-100.justify-content-center.align-items-center.d-flex(v-if='dadosGrafico.erro')
                                    span {{ $t('mensagens.operacao.dashboard.erroInformacoesTotalizadores') }}

                                div.w-100.h-100.justify-content-center.align-items-center.d-flex(v-else-if='!dadosGrafico.payload || dadosGrafico.payload.length === 0')
                                    span {{ $t('mensagens.operacao.dashboard.semInformacoesTotalizadores') }}

                                GraficoColuna(
                                    v-else
                                    id='card-totalizadores-dashboard-operacao__grafico-grafico',
                                    type='ColumnChart',
                                    :data='dadosGrafico.payload',
                                    :options='opcaoGrafico'
                                )

                            .card-totalizadores-dashboard-operacao__grafico__tabela--tabela(
                                v-else
                                :style='dadosTabela.erro || !dadosTabela.payload ? "opacity: 0.7" : ""'
                            )
                                div.w-100.h-100.justify-content-center.align-items-center.d-flex(v-if='dadosTabela.erro')
                                    span {{ $t('mensagens.operacao.dashboard.erroTabelaTotalizadores') }}

                                div.w-100.h-100.justify-content-center.align-items-center.d-flex(v-else-if='!dadosTabela.payload || dadosTabela.payload.itens.length === 0')
                                    span {{ $t('mensagens.operacao.dashboard.semTabelaTotalizadores') }}

                                TabelaDinamicaDashboardOperacao(
                                    v-else
                                    :payload='dadosTabela.payload'
                                )

                            .card-totalizadores-dashboard-operacao__grafico__tabela--footer
                                el-button-group
                                    BaseButton(
                                        icon='mdi mdi-chart-box-outline'
                                        type='primary'
                                        @click='buscarDadosGrafico'
                                        style='font-size: 27px; padding: 3px; width: 75px'
                                        :style='styleButtonGrafico'
                                    )
                                    BaseButton(
                                        icon='mdi mdi-list-box-outline'
                                        type='primary'
                                        @click='buscarDadosTabela'
                                        style='font-size: 27px; padding: 3px; width: 75px'
                                        :style='styleButtonTabela'
                                    )
</template>

<script>
import { GChart as GraficoColuna } from 'vue-google-charts/legacy';
import TabelaDinamicaDashboardOperacao from '@/components/operacao/dashboard/TabelaDinamicaDashboardOperacao.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'CardTotalizadoresDashboardOperacao',
    components: {
        GraficoColuna,
        TabelaDinamicaDashboardOperacao,
        BaseButton
    },
    emits: ['atualizarGraficoTotalizadores'],
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        payload: {
            type: Array,
            required: true,
            default: () => (
                [
                    {
                        total: null,
                        codigo: null,
                        descricao: null,
                        selecionado: false
                    }
                ]
            )
        },
        erro: {
            type: Boolean,
            default: false
        },
        dadosGrafico: {
            type: Object,
            required: true,
            default: () => ({
                loading: false,
                erro: false,
                payload: [
                    {
                        total: 23500,
                        mes: 'JAN/23',
                        descricao: this.$t('mensagens.operacao.dashboard.territoriosCadastrados'),
                        descricaoTotal: '23.500 territórios'
                    }
                ]
            })
        },
        dadosTabela: {
            type: Object,
            required: true,
            default: () => ({
                loading: false,
                erro: false,
                payload: {
                    colunas: ['dataCadastro', 'nome', 'localidade', 'areaHa'],
                    codigo: 'TERRITORIOS_CADASTRADOS',
                    itens: [
                        {
                            dataCadastro: '',
                            nome: '',
                            localidade: '',
                            areaHa: '',
                            id: 0
                        }
                    ],
                    visualizar: true
                }
            })
        }
    },

    data: () => ({
        styleButtonGrafico: {
            backgroundColor: '#94cf1c',
            borderColor: '#94cf1c',
            color: '#00413c'
        },
        styleButtonTabela: {
            backgroundColor: '#00413c',
            borderColor: '#00413c',
            color: '#fff'
        },
        codigoTotalizadorSelecionado: null,
        opcaoGrafico: {
            title: '',
            width: '100%',
            height: 550,
            colors: ['#00413c'],
            tooltip: { isHtml: true },
            legend: { position: 'none' },
            chartArea: { width: '80%', height: '550px' },
            animation: {
                duration: 600,
                easing: 'out',
                startup: true
            }
        },
        mostrarGrafico: true,
        loadingSkeleton: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
        errorPayload: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    }),

    methods: {
        definirEspacamentoColunas(index) {
            return index % 2 === 0 ? 'pr-1' : 'pl-1';
        },

        selecionarCardTotalizador(camada) {
            this.codigoTotalizadorSelecionado = camada.codigo;
            const camadaSelecionada = this.payload.find((camada) => camada.selecionado === true);
            camadaSelecionada.selecionado = false;

            camada.selecionado = true;

            this.opcaoGrafico.title = `${this.$t('mensagens.operacao.dashboard.totalizadorSelecionado')}: ${camada.descricao}`;

            if (this.mostrarGrafico) {
                this.$emit('atualizarGraficoTotalizadores', this.codigoTotalizadorSelecionado);
                this.dadosTabela.payload = null;
            } else {
                this.$emit('atualizarTabelaTotalizadores', this.codigoTotalizadorSelecionado);
                this.dadosGrafico.payload = null;
            }
        },

        buscarDadosTabela() {
            this.mostrarGrafico = false;

            if (!this.dadosTabela.payload) {
                this.$emit('atualizarTabelaTotalizadores', this.codigoTotalizadorSelecionado);
            }
            this.styleButtonGrafico = {
                backgroundColor: '#00413c',
                borderColor: '#00413c',
                color: '#fff'
            };
            this.styleButtonTabela = {
                backgroundColor: '#94cf1c',
                borderColor: '#94cf1c',
                color: '#00413c'
            };
        },

        buscarDadosGrafico() {
            this.mostrarGrafico = true;

            if (!this.dadosGrafico.payload || this.dadosGrafico.payload.length === 0) {
                this.$emit('atualizarGraficoTotalizadores', this.codigoTotalizadorSelecionado);
            }
            this.styleButtonGrafico = {
                backgroundColor: '#94cf1c',
                borderColor: '#94cf1c',
                color: '#00413c'
            };
            this.styleButtonTabela = {
                backgroundColor: '#00413c',
                borderColor: '#00413c',
                color: '#fff'
            };
        },

        definirCorCard(camada) {
            return camada.selecionado === true ? 'background-color: #b5dc69; border-color: #b5dc69' : '';
        }
    }
};
</script>

<style lang='scss' scoped>
#card-totalizadores-dashboard-operacao {

    .colunas__card {
        height: 90px;
    }

    .card-totalizadores-dashboard-operacao__card {
        display: flex;
        flex-direction: column;
        height: 90px;
        border-radius: 5px;
        background-color: var(--white);
        border: solid 1px var(--default-border-color);
        box-shadow: 0 1px 3px 0 var(--block-shadow);;
        padding: 0 20px;
        text-align: center;
        justify-content: center;
        margin-bottom: 20px;
        position: relative;
        cursor: pointer;

        .card-totalizadores-dashboard-operacao__total {
            color: var(--primary);
            font-size: 26px;
            font-weight: 600;
        }

        .card-totalizadores-dashboard-operacao__descricao {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            padding-bottom: 0;
        }
    }

    .card-totalizadores-dashboard-operacao__grafico__tabela {
        background: white;
        height: 600px;
        width: 100%;
        border-radius: 5px;
        box-shadow: 0 1px 3px 0 var(--block-shadow);
        overflow: hidden;

        .card-totalizadores-dashboard-operacao__grafico__tabela--grafico {
            height: 530px;
            overflow: hidden;
        }

        .card-totalizadores-dashboard-operacao__grafico__tabela--tabela {
            height: 530px;
            overflow-y: auto;
        }

        .card-totalizadores-dashboard-operacao__grafico__tabela--footer {
            height: 70px;
            border-top: solid 2px #e0e0e0;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .card-totalizadores-dashboard-operacao__cards__skeleton {
        height: 90px;
        width: 100%;
        border-radius: 5px;
    }

    .card-totalizadores-dashboard-operacao__grafico__tabela--skeleton {
        height: 100%;
        width: 100%;
        border-radius: 5px;
    }
}
</style>
